export class JWTToken {
  public token: string;
  public refreshToken?: string;
  public expireAt: number;
  public issuedAt: number;
  public forcePasswordChange?: boolean;

  constructor(token: string, refreshToken?: string) {
    this.token = token;
    this.refreshToken = refreshToken;
  }

  public set setExpireAt(tokenInterface: JWTTokenAPI) {
    this.expireAt = tokenInterface.exp;
  }

  public set setIssuedAt(tokenInterface: JWTTokenAPI) {
    this.issuedAt = tokenInterface.iat;
  }

  public set setForcePasswordChange(tokenInterface: JWTTokenAPI) {
    this.forcePasswordChange = tokenInterface.forcePasswordChange;
  }
}

export class JWTTokenAPI {
  exp: number;
  iat: number;
  forcePasswordChange: boolean;
  username: string;
  roles: Array<string>;
}
